module.exports = __webpack_public_path__ + "img/logo.037d45a5.png";